import { createSelector } from '@reduxjs/toolkit';
import { JobStatesListState } from 'ducks/job-states-list/slices';
import { RootState } from 'store';

const jobStatesListSlice = (state: RootState) => state.job_states_list;

export const selectJobStatesList = createSelector([jobStatesListSlice], (state): JobStatesListState => state);
